var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#002D70"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6353 22.1218C12.4637 23.2934 12.4637 25.1929 13.6353 26.3645C14.8069 27.5361 16.7064 27.5361 17.8779 26.3645L19.9993 24.2432C20.3898 23.8526 21.0229 23.8526 21.4135 24.2432C21.804 24.6337 21.804 25.2669 21.4135 25.6574L19.2921 27.7787C17.3395 29.7313 14.1737 29.7313 12.2211 27.7787C10.2685 25.8261 10.2685 22.6603 12.2211 20.7076L14.3424 18.5863C14.7329 18.1958 15.3661 18.1958 15.7566 18.5863C16.1471 18.9768 16.1471 19.61 15.7566 20.0005L13.6353 22.1218Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3647 17.8782C27.5363 16.7066 27.5363 14.8071 26.3647 13.6355C25.1931 12.4639 23.2936 12.4639 22.1221 13.6355L20.0007 15.7568C19.6102 16.1474 18.9771 16.1474 18.5865 15.7568C18.196 15.3663 18.196 14.7331 18.5865 14.3426L20.7079 12.2213C22.6605 10.2687 25.8263 10.2687 27.7789 12.2213C29.7315 14.1739 29.7315 17.3397 27.7789 19.2924L25.6576 21.4137C25.2671 21.8042 24.6339 21.8042 24.2434 21.4137C23.8529 21.0232 23.8529 20.39 24.2434 19.9995L26.3647 17.8782Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7578,
    y: 22.8281,
    width: 10,
    height: 2,
    rx: 1,
    transform: "rotate(-45 15.7578 22.8281)",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CopyLink.1e8ecfd0e6bf5b49c75337af6871ba22.svg";